<template>
  <div class="forms">
    <Submitted 
      v-if="submitted" 
      @resetEnquiry="resetEnquiry" 
      :submissionId="submissionId"
    />    
    <TheMarriageApplicationForm v-else @submitEnquiry="submitEnquiry" />
  </div>
</template>

<script>
import Submitted from '@/components/marriageApplication/Submitted.vue'
import TheMarriageApplicationForm from '../../components/marriageApplication/TheMarriageApplicationForm.vue';

export default {
  name: 'TheMarriageApplication',
  components: {
    TheMarriageApplicationForm,
    Submitted,
  },
  data: function() {
    return {
      submitted: false,
      submissionId: ''
    }
  },
  methods: {
    submitEnquiry: function(result) {
      this.submitted = result.response == 'OK';
      this.submissionId = result.submissionId;
      scroll(0, 0);
    },
    resetEnquiry: function() {
      this.submitted = false;
      scroll(0, 0); 
    }
  }
}
</script>

